<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>

      <div style="height: 30px;"></div>
      <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" >
        <template v-slot:activator="{ on }">
          <v-text-field v-model="shippingDate" :label="$t('sales.store-arrival-day')" prepend-icon="event" readonly v-on="on" ></v-text-field>
        </template>
        <v-date-picker
          v-model="shippingDateForPicker"
          @input="menu2 = false"
          locale="jp-ja"
          :day-format="date => new Date(date).getDate()"
          no-title
          :events="functionEvents"
          event-color="green lighten-1"
          @change="onChangeShippingDate()"
        ></v-date-picker>
      </v-menu>

      <div style="height: 35px;"></div>
      
      <!-- 출하확인 버튼-->
      <div class="text-xs-center">
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on }">
            <v-btn align-center block color="info" v-on="on" v-bind:disabled="!dispShippingConfirmBtn" @click="getShippingStatus()" >
              <v-icon dark left>local_shipping</v-icon>
              {{ $t('sales.shipment-status') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline grey lighten-2" style="padding: 10px;" >{{ $t('sales.shipment-status') }}</v-card-title>
            <!-- 출하확인 팝업의 내용 -->
            <v-container>
              <v-data-table
                :headers="shippingHeaders"
                :items="shippingItems"
                hide-actions
                class="elevation-1"
                style="width: 100%; margin: 15px 0 0;"
                :no-data-text="$t('noTableDataAvailable')"
              >
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ props.header.text }}</span>
                    </template>
                    <span>{{ props.header.text }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:items="props">
                  <tr @click="shippingDetailEvent(props.item)">
                    <td class="text-xs-left px-3">{{ props.item.slipNumber }}</td>
                    <td class="text-xs-left px-3">{{ props.item.status }}</td>
                    <td class="text-xs-left px-3">{{ props.item.createdUser }}</td>
                  </tr>
                </template>
              </v-data-table>

              <v-flex v-if="shippingDetailDisp">
                <v-divider style="margin: 30px;"></v-divider>

                <div class="subheading" style="text-align:left;">{{ selectedSlipNumber }}</div>
                <div class="subheading" style="text-align:left;">{{ selectedShippingStatus }}</div>
                <div class="subheading" style="text-align:right;">{{ selectedCreatedUser }}</div>

                <v-data-table
                  :headers="shippingItemDetailHeaders"
                  :items="shippingItemDetail"
                  :customFilter="shippingItemsFilter"
                  :search="selectedOrderManagementId"
                  hide-actions
                  class="elevation-1"
                  style="width: 100%;    margin: 15px 0 0;"
                  :no-data-text="$t('noTableDataAvailable')"
                >
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ props.header.text }}</span>
                      </template>
                      <span>{{ props.header.text }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:items="props">
                    <tr>
                      <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                      <td class="text-xs-right px-2">{{ props.item.quantity }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>

              <v-divider style="margin: 30px;"></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="dialog = false">{{ $t('close') }}</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
      </div>

      <div style="height: 35px;"></div>

      <!-- 発注履歴(화면의 발주이력) -->
      <v-card v-if="isOrdered">
        <v-container>
          <v-card-title>{{ $t('sales.order-history') }}</v-card-title>
          <v-layout row wrap align-center>
            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="orderedItems"
              hide-actions
              class="elevation-1"
              style="width: 100%;    margin: 15px 0 0;"
              :customFilter="customFilter"
              :search="search"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              
              <template v-slot:items="props">
                <tr v-bind:class="{'is-ordered': isOrdered}">
                  <td class="text-xs-left" style="padding: 5px !important;">{{ props.item.janCode }}</td>
                  <td class="text-xs-left" style="padding: 5px !important;">{{ props.item.itemName }}</td>

                  <!-- 이번에 추가한것 -->
                  <td 
                    v-if="props.item.arrivalDateOrderQuantity !='0'" 
                    class="text-xs-center" 
                    style="padding: 5px !important;"
                  >
                      {{ props.item.shippingDate }}({{ props.item.arrivalDateOrderQuantity }})
                  </td>
                  <td 
                    v-else class="text-xs-center" 
                    style="padding: 5px !important;"
                  >
                    {{ props.item.arrivalDateOrderQuantity }}
                  </td>
                  
                  <td 
                    class="text-xs-right" 
                    style="padding: 5px !important;"
                  >
                    <input type="number" name="itemNum[]" v-model="props.item.quantity" v-bind:disabled="isOrdered" class="column-input-for-order" min="0" />
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
          
          <!-- 추가 발주의뢰 버튼 -->
          <div style="height: 35px;"></div>
          <v-layout row wrap>
            <v-flex xs12 sm12 v-if="dispAddOrderBtn && orderLocked !== '1'">
              <v-btn block color="success" dark @click="addOrder()">
                <v-icon dark left>add_circle_outline</v-icon>
                {{ $t('sales.order-add-order-request-btn') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>
      <v-card v-if="(dispAddOrderForm || fromOrderSendConfirm) && orderLocked !== '1'">
        <v-container>
          <v-card-title>
            {{ $t('sales.order-send-subtitle-send-by-input') }}
            &nbsp;
            <v-btn color="primary" dark small class="font-weight-black">
              <v-icon dark left small>thumb_up</v-icon>
              {{ $t('sales.order-notice1') }}
            </v-btn>
          </v-card-title>
          <v-alert :value="true" color="error" icon="info" outline class="font-weight-bold" style="text-align: left;" >{{ $t('sales.order-notice2') }}</v-alert>

          <div style="height: 30px;"></div>
          <v-layout row wrap align-center>

            <!-- Jan Code검색 -->
            <v-flex xs12>
              <v-text-field
                type="Number"
                min="0"
                v-model="search"
                append-icon="search"
                :label="$t('sales.stocktaking-search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>
            <v-data-table
              :headers="headers"
              :items="orderItems"
              hide-actions
              class="elevation-1"
              style="width: 100%; margin: 15px 0 0;"
              :customFilter="customFilter"
              :search="search"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template v-slot:items="props" >
                <tr>                 
                  <!-- JAN Code -->
                  <td
                    class="text-xs-left"
                    :class="getOrderCellClass(props.item)"
                    style="padding: 5px !important;"
                  >
                    {{ props.item.janCode }}
                  </td>

                  <!-- 상품명 -->
                  <td
                    class="text-xs-left"
                    :class="getOrderCellClass(props.item)"
                    style="padding: 5px !important;"
                  >
                    {{ props.item.itemName }}
                  </td>

                  <!-- 발주완료정보 -->
                  <td
                    v-if="props.item.arrivalDateOrderQuantity != '0'"
                    class="text-xs-center"
                    :class="getOrderCellClass(props.item)"
                    style="padding: 5px !important;"
                  >
                    {{ props.item.shippingDate }}({{ props.item.arrivalDateOrderQuantity }})
                  </td>

                  <td
                    v-else
                    class="text-xs-center"
                    :class="getOrderCellClass(props.item)"
                    style="padding: 5px !important;"
                  >
                    {{ props.item.arrivalDateOrderQuantity }}
                  </td>

                  <!-- 수량 -->
                  <td
                    class="text-xs-right"
                    :class="getOrderCellClass(props.item)"
                    style="padding: 5px !important;"
                  >
                    <input
                      type="number"
                      name="itemNum[]"
                      v-model.number="props.item.quantity"
                      class="column-input-for-order"
                      min="0"
                      :max="props.item.orderLimitNumber"
                      @input="onChangeOrderNum(props.item)"
                    />
                  </td>
                </tr>
              </template>
            </v-data-table>

            <!-- 참고 재고수 등록 팝업(사용하지 않음) -->
            <!-- <v-dialog v-model="updateDialog" max-width="500px">
              <v-card>
                <v-card-title class="headline grey lighten-2 pa-3">参考在庫の修正</v-card-title>
                <v-container>
                  <v-container grid-list-md>
                    <v-layout row warp>
                      <p class="font-weight-bold text-xs-left">
                        {{ $t('sales.product-name') }}:
                        {{ this.editedItem.itemName }}
                      </p>
                    </v-layout>
                    <v-layout row warp>
                      <p class="font-weight-bold text-xs-left" >発注上限: {{ this.editedItem.orderLimitNumber }}</p>
                    </v-layout>
                    <v-layout row warp align-content-center>
                      <v-flex xs5 sm5>
                        <v-text-field
                          v-model="editedItem.referenceStock"
                          value="0"
                          :label="$t('attributes.reference-stock')"
                          type="number"
                          min="0"
                          @click="editedItem.referenceStock = ''"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">
                      <v-icon dark>arrow_back</v-icon>
                      {{ $t('back-btn') }}
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click="updateReferenceStock()">
                      <v-icon dark>save</v-icon>
                      {{ $t('update-btn') }}
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog> -->

            <v-flex xs12 sm12>
              <div style="height: 30px;"></div>
            </v-flex>

            <!-- 비고 -->
            <v-flex xs12 sm12>
              <v-textarea
                outline
                v-model="remarks"
                counter="1000"
                :label="$t('sales.order-remarks')"
                clearable
              ></v-textarea>
            </v-flex>

            <!-- 입력내용 확인 버튼 -->
            <v-flex xs12 sm12 style="margin: 50px 0 15px;">
              <v-btn
                block
                color="#4C728A"
                dark
                @click="forwardConfirm()"
              >{{ $t('sales.check-entries') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <!-- 이미지 송신 -->
      <div style="height: 35px;"></div>
      <v-card v-if="dispAddOrderForm && orderLocked !== '1'">
        <v-container>
          <v-card-title>
            {{ $t('sales.order-send-subtitle-send-by-image') }}
          </v-card-title>

          <v-layout row wrap align-center>
            <v-flex xs12 sm12 style="margin: 5px 0px 20px;">
              <v-btn block color="#4C728A" dark @click="forwardSendImage()">
                {{ $t('sales.order-image-send-btn') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'sales/new-user-menu' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('created')

    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.$store.commit('SET_ORDER_DISP_ADD_ORDER_FORM', true)
    this.fromOrderSendConfirm = this.$route.params.fromOrderSendConfirm
    this.getOrderItems()
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    }),
    shippingDate: {
      get() {
        return this.$store.state.salesSession.orderSelectedShippingDate
      },
      set(value) {
        this.$store.commit('SET_ORDER_SELECTED_SHIPPING_DATE', value)
      }
    },
    selectedOrderItems: {
      get() {
        return this.$store.state.salesSession.orderSelectedOrderItems
      },
      set(value) {
        this.$store.commit('SET_ORDER_SELECTED_ITEMS', value)
      }
    },
    dispAddOrderForm: {
      get() {
        return this.$store.state.salesSession.dispAddOrderForm
      },
      set(value) {
        this.$store.commit('SET_ORDER_DISP_ADD_ORDER_FORM', value)
      }
    },
    remarks: {
      get() {
        return this.$store.state.salesSession.remarks
      },
      set(value) {
        this.$store.commit('SET_ORDER_REMARKS', value)
      }
    }
  },
  methods: {
    getOrderCellClass(item) {
      const quantity = Number(item.quantity)
      const orderLimitNumber = Number(item.orderLimitNumber)

      // 제한 초과 또는 음수
      if (quantity > orderLimitNumber || quantity < 0) {
        return 'changed-over-class-name-order-send'
      }

      // 정상 범위에서 수량 변경
      if (item.isChanged) {
        return 'changed-class-name'
      }

      return ''
    },
    customFilter(items, search) {
      console.log('custom filter')

      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.janCode.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getOrderItems() {
      let thisObj = this

      let selectedStoreCode = this.selectedStore.storeCode
      let request = {
        storeCode: selectedStoreCode,
        shippingDate: this.shippingDate.replace(/\//g, '')
      }

      ServerApiCallService.orderItems(request)
        .then(response => {
          thisObj.isOrdered = response.data.isOrdered

          // 발주의뢰 한 데이타 변형
          if (thisObj.isOrdered) {
            this.$store.commit('SET_ORDER_DISP_ADD_ORDER_FORM', false)
            this.orderedItems = response.data.orderedItems


            // 도착일자 변형(20241106 → 11/06)
            thisObj.orderedItems.forEach(function(row) {
              if(row.shippingDate) {
                row.shippingDate = row.shippingDate.substr(4, 2) + '/' + row.shippingDate.substr(6)
              }            
            })

            // 발주이력이 가끔 화면을 갱신해야 데이타가 반영되는걸 이 메소드를 실행하는걸로 대신한다
            this.getShippingStatus()
          }
          
          // 화면에 비표시 상품은 제외한다다
          let tmpOrderItems = [];
          response.data.items.forEach(function(row) {

            // hiro-yayoi 점포는 모든 상품을 표시
            if (selectedStoreCode === "hiro-yayoi") {
              tmpOrderItems.push(row)
            } else {
              // hiro-yayoi 점포 이외는 서버에서 표시 가능한 상품만 가지고 오지만 다시한번 체크한다
              if (row.displayOnScreen === '0') {
                tmpOrderItems.push(row)
              }
            }
          })
          
          thisObj.hasImage = response.data.hasImage
          thisObj.orderItems = tmpOrderItems
          
          // 商品の表示順 商品カテゴリ、商品名
          thisObj.orderItems.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })

          thisObj.orderItems.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })

          // 数値が入力されたstateから数値を設定する
          thisObj.orderItems.forEach(function(row) {
            let itemCode = row.itemCode
            thisObj.selectedOrderItems.forEach(function(rowSelected) {
              if (itemCode === rowSelected.itemCode) {
                row.quantity = rowSelected.quantity
              }
            })
          })

          thisObj.orderLocked = response.data.orderLocked
          
          // 도착일자 변형(20241106 → 11/06)
          thisObj.orderItems.forEach(function(row) {            
            if(row.shippingDate) {
              row.shippingDate = row.shippingDate.substr(4, 2) + '/' + row.shippingDate.substr(6)
            }            
          })

          this.existOrderByUser()
        }).catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    onChangeShippingDate() {
      console.log('change shipping date')

      this.shippingDate = this.shippingDateForPicker.replace(/-/g, '/')
      this.dispAddOrderForm = true
      this.$store.commit('SET_ORDER_DISP_ADD_ORDER_FORM', true)
      this.fromOrderSendConfirm = false

      console.log('moment selected date: ' + moment(this.shippingDateForPicker).format('YYYYMMDD'))
      console.log('now date: ' + moment().format('YYYYMMDD'))

      // 過去の日付の場合、発注不可とする
      if (moment(this.shippingDateForPicker).format('YYYYMMDD') < moment().format('YYYYMMDD')) {
        this.dispAddOrderBtn = false
        this.dispAddOrderForm = false
      } else {
        this.dispAddOrderBtn = true
      }

      console.log("dispAddOrderForm1111: ", this.dispAddOrderForm);
      console.log("fromOrderSendConfirm1111: ", this.fromOrderSendConfirm);
      console.log("orderLocked1111: ", this.orderLocked);
      

      this.getOrderItems()
      this.shippingDetailDisp = false
    },
    onChangeOrderNum(changedItem) {
      console.log('change order num')
      console.log('quantity:', changedItem.quantity)
      console.log('orderLimitNumber:', changedItem.orderLimitNumber)
      
      // changedItem.isChanged = true
      this.$set(changedItem, 'isChanged', true)

      const quantity = Number(changedItem.quantity)
      const orderLimitNumber = Number(changedItem.orderLimitNumber)

      if (quantity > orderLimitNumber) {
        this.$parent.$parent.$parent.showResultDialog(
          this.$t('sales.over-number-of-limit'),
          null,
          true
        )
      }
      if (quantity < 0) {
        this.$parent.$parent.$parent.showResultDialog(
          this.$t('sales.minus-quantity'),
          null,
          true
        )
      }
    },
    forwardConfirm() {
      console.log('forward confirm')

      let itemsFilterlingOrderNum = this.orderItems.filter(
        item => item.quantity > 0
      )

      this.selectedOrderItems = itemsFilterlingOrderNum

      // 도착일자를 지정하지 않은경우
      if (this.shippingDate === '') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.non-selected-shipping-date')
        )
        return
      }

      // 주문을 하지 않고 버튼을 누룬경우
      if (this.selectedOrderItems.length == 0) {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.non-selected-order-items')
        )
        return
      }

      // 확인 화면으로 이동
      this.$router.push({
        name: 'sales/new-order-send-confirm',
        params: {}
      })
    },
    forwardSendImage() {
      console.log('forward send image')

      if (this.shippingDate === '') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.non-selected-shipping-date')
        )
        return
      }

      this.$router.push({
        name: 'sales/new-order-send-by-image'
      })
    },
    addOrder() {
      this.$store.commit('SET_ORDER_DISP_ADD_ORDER_FORM', true)
    },
    allowedDates: val => new Date(val).getTime() > new Date().getTime(),
    existOrderByUser() {
      console.log('now date: ' + moment().format('YYYYMMDD'))

      var requestShippingDate = ''
      if (!this.shippingDateForPicker) {
        requestShippingDate = moment().format('YYYYMMDD')
      } else {
        requestShippingDate = moment(this.shippingDateForPicker).format('YYYYMMDD')
      }

      let request = {
        storeCode: this.selectedStore.storeCode,
        shippingDate: requestShippingDate
      }

      ServerApiCallService.existOrderByUser(request)
        .then(response => {
          this.existsOrderData = response.data.existsOrders
          
          if (!!this.shippingDateForPicker && this.existsOrderData.includes(requestShippingDate)) {
            this.dispShippingConfirmBtn = true
          } else {
            this.dispShippingConfirmBtn = false
          }
        })
        .catch(error => {})
    },
    functionEvents(date) {
      var day = date.replace(/-/g, '')
      if (this.existsOrderData.includes(day)) return true
    },
    getShippingStatus() {
      let request = {
        storeCode: this.selectedStore.storeCode,
        shippingDate: this.shippingDate.replace(/\//g, '')
      }

      ServerApiCallService.getShippingStatus(request)
        .then(response => {
          this.shippingItems = response.data.orders
          this.shippingItems.forEach(item => {
            if (!item.slipNumber) {
              item.slipNumber = this.$t('sales.shipment-status-preparation')
            } else {
              item.status = this.$t('sales.shipment-status-complete')
            }
          })
          this.shippingItemDetail = response.data.shippingItems
        })
        .catch(error => {})
    },
    shippingDetailEvent(selectedItem) {
      this.shippingDetailDisp = true
      this.selectedOrderManagementId = selectedItem.orderManagementId
      this.selectedSlipNumber = selectedItem.slipNumber
      this.selectedShippingStatus = selectedItem.status
      this.selectedCreatedUser = selectedItem.createdUser
    },
    shippingItemsFilter(items, search) {
      if (!search) {
        return items
      } else {
        return items.filter(item => item.orderManagementId == search)
      }
    },
    editReferenceStock(item) {
      console.log('editReferenceStock')
      console.log(item)

      this.editedItem = Object.assign({}, item)
      this.updateDialog = true
    },
    close() {
      this.updateDialog = false
    },
    updateReferenceStock() {
      console.log('updateReferenceStock')

      let thisObj = this

      let request = {
        storeCode: this.selectedStore.storeCode,
        itemCode: this.editedItem.itemCode,
        referenceStock: Number(this.editedItem.referenceStock)
      }

      ServerApiCallService.updateReferenceStock(request)
        .then(response => {
          this.orderItems.forEach(function(row) {
            if (row.itemCode == thisObj.editedItem.itemCode) {
              row.referenceStock = thisObj.editedItem.referenceStock
            }
          })
          this.updateDialog = false
          thisObj.editedItem = {}
        })
        .catch(error => {
          this.updateDialog = false
        })
    }
  },
  data() {
    return {
      editedItem: {},
      updateDialog: false,
      search: '',
      dispAddOrderBtn: true,
      shippingDateForPicker: '',
      menu: false,
      modal: false,
      menu2: false,
      selectCategory: { itemCategoryId: '' },
      // itemCategories: [],
      orderItems: [],
      isOrdered: false,
      hasImage: false,
      fromOrderSendConfirm: false,
      orderLocked: '0',
      dialog: false,
      existsOrderData: [],
      dispShippingConfirmBtn: false,
      selectedOrderManagementId: '',
      selectedSlipNumber: '',
      selectedShippingStatus: '',
      selectedCreatedUser: '',
      headers: [
        {
          text: 'JanCode',
          align: 'left',
          value: 'janCode',
          sortable: false,
          fixed: false,
          width: '15%',
          class: 'px-2'
        },
        {
          text: '商品名',
          align: 'left',
          value: 'productName',
          sortable: false,
          width: '45%',
          fixed: false,
          class: 'px-2'
        },
        {
          text: '発注済情報',
          align: 'center',
          sortable: false,
          value: 'itemNum',
          width: '25%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: '数量',
          align: 'right',
          sortable: false,
          value: 'itemNum',
          width: '15%',
          fixed: true,
          class: 'px-2'
        }
      ],
      shippingHeaders: [
        {
          text: '伝票番号',
          align: 'left',
          value: 'slipNumber',
          sortable: false,
          fixed: false,
          class: 'px-3'
        },
        {
          text: 'ステータス',
          align: 'left',
          value: 'status',
          sortable: false,
          fixed: false,
          class: 'px-1'
        },
        {
          text: '発注者',
          align: 'left',
          value: 'createdUser',
          sortable: false,
          fixed: false,
          class: 'px-1'
        }
      ],
      shippingItems: [],
      shippingDetailDisp: false,
      shippingItemDetailHeaders: [
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: '個数',
          align: 'right',
          value: 'itemNum',
          sortable: false,
          fixed: false,
          class: 'px-2'
        }
      ],
      shippingItemDetail: []
    }
  }
}
</script>

<style scoped>
td.changed-class-name {
  background-color: #d0e0ff !important;
}

td.changed-over-class-name-order-send {
  background-color: #ff6262 !important;
}

.column-input-for-order {
  width: 55px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 5px;
}
th.order-limit-column.text-xs-right {
  padding: 0 5px !important;
  white-space: pre-wrap !important;
  /*  width: 50px !important;*/
}
td.order-limit-column.text-xs-right {
  padding: 0 5px 0 0 !important;
  /*  width: 50px !important;*/
}
.order-limit-column.text-xs-right {
  text-align: right !important;
}
.column {
  padding: 0 5px !important;
}
.is-ordered {
  background-color: #adadad;
}
</style>
